import React from "react";

function ConsultantTab({ data = {}, onChange }) {
  const handleInput = (e) => {
    const { name, value } = e.target;
    onChange({ ...data, [name]: value });
  };

  return (
    <div className="bg-white p-3 rounded-md shadow-md border">
      <div className="grid grid-cols-2 md:grid-cols-3 gap-4 text-sm">

        {/* Name */}
        <div className="flex flex-col">
          <label className="text-gray-600 font-medium mb-1">Name</label>
          <input
            name="name"
            value={data.name || ""}
            onChange={handleInput}
            className="border rounded px-2 py-1 focus:ring-2 focus:ring-blue-400"
            placeholder="Enter name"
          />
        </div>

        {/* Specialty */}
        <div className="flex flex-col">
          <label className="text-gray-600 font-medium mb-1">Specialty</label>
          <input
            name="specialty"
            value={data.specialty || ""}
            onChange={handleInput}
            className="border rounded px-2 py-1"
            placeholder="Enter specialty"
          />
        </div>

        {/* Hourly Rate */}
        <div className="flex flex-col">
          <label className="text-gray-600 font-medium mb-1">Hourly Rate</label>
          <input
            name="hourly_rate"
            value={data.hourly_rate || ""}
            onChange={handleInput}
            className="border rounded px-2 py-1"
            placeholder="Enter hourly rate"
          />
        </div>

        {/* Contact Email */}
        <div className="flex flex-col">
          <label className="text-gray-600 font-medium mb-1">Contact Email</label>
          <input
            type="email"
            name="contact_email"
            value={data.contact_email || ""}
            onChange={handleInput}
            className="border rounded px-2 py-1"
            placeholder="Enter email"
          />
        </div>

        {/* Phone */}
        <div className="flex flex-col">
          <label className="text-gray-600 font-medium mb-1">Phone</label>
          <input
            name="phone"
            value={data.phone || ""}
            onChange={handleInput}
            className="border rounded px-2 py-1"
            placeholder="Enter phone number"
          />
        </div>

      </div>
    </div>
  );
}

export default ConsultantTab;
